module.exports = __webpack_public_path__ + "img/computer-speaker.146442eb.svg";